import getSelectedTableView from "../utils/getSelectedTableView";
import { owaComputedFn } from "owa-computed-fn";

const getComputedIsGroupHeaderSelected: () => boolean = owaComputedFn((): boolean => {
    return !!getSelectedTableView()?.headerToFocus;
});
export default getComputedIsGroupHeaderSelected;
